import React, { forwardRef, useImperativeHandle, useState, useRef } from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../../assets/image/logo1.png";

const DailyCashReportPDF = forwardRef((props, ref) => {
  const [reportData, setReportData] = useState(props.reportData || null);
  const docRef = useRef(null);

  useImperativeHandle(ref, () => ({
    generatePDF: (data = null) => {
      // Use provided data or existing reportData
      const pdfData = data || reportData;
      if (!pdfData) {
        console.error("No data provided for PDF generation");
        return;
      }
      generatePDFDocument(pdfData);
    },
    setReportData: (data) => {
      setReportData(data);
    }
  }));

  const generatePDFDocument = (data) => {
    const doc = new jsPDF();
    docRef.current = doc;

    // Add Logo
    if (logo) {
      try {
        doc.addImage(logo, "PNG", 15, 10, 35, 20);
      } catch (error) {
        console.warn("Could not load logo:", error);
      }
    }

    // Title
    doc.setFontSize(20);
    doc.text("DAILY CASH REPORT", 105, 20, { align: "center" });

    // Date
    doc.setFontSize(11);
    doc.text(`Date: ${data.date}`, 15, 40);
    doc.text(`Generated At: ${new Date().toLocaleTimeString()}`, 15, 47);

    // Summary Table
    autoTable(doc, {
      startY: 55,
      head: [["Application Type", "Fee (₹)", "Count", "Total Amount (₹)"]],
      body: [
        ["Zone Certificate", "200", data.zone.count, data.zone.count * 200],
        ["Part Plan", "700", data.partplan.count, data.partplan.count * 700],
        [
          "GRAND TOTAL",
          "",
          data.zone.count + data.partplan.count,
          data.zone.count * 200 + data.partplan.count * 700,
        ],
      ],
      theme: "grid",
      headStyles: { fillColor: [41, 128, 185] },
      margin: { left: 15, right: 15 },
    });

    // Detailed Zone Records
    if (data.zone.records && data.zone.records.length > 0) {
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 10,
        head: [["Sr.No", "Application ID", "Applicant Name", "Amount (₹)"]],
        body: data.zone.records.map((row, index) => [
          index + 1,
          row.appId || row.request_unique_id || `ZON${String(index + 1).padStart(3, '0')}`,
          row.name || row.applicantName || "N/A",
          "200",
        ]),
        theme: "grid",
        headStyles: { fillColor: [39, 174, 96] },
        margin: { left: 15, right: 15 },
      });
    }

    // Detailed Part Plan Records
    if (data.partplan.records && data.partplan.records.length > 0) {
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + (data.zone.records && data.zone.records.length > 0 ? 10 : 0),
        head: [["Sr.No", "Application ID", "Applicant Name", "Amount (₹)"]],
        body: data.partplan.records.map((row, index) => [
          index + 1,
          row.appId || row.request_unique_id || `PP${String(index + 1).padStart(3, '0')}`,
          row.name || row.applicantName || "N/A",
          "700",
        ]),
        theme: "grid",
        headStyles: { fillColor: [142, 68, 173] },
        margin: { left: 15, right: 15 },
      });
    }

    // Payment Mode Summary
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 10,
      head: [["Mode", "Count", "Amount (₹)"]],
      body: [
        ["Cash", data.payment.online.count, data.payment.online.amount],
        ["Online", data.payment.cash.count, data.payment.online.amount + data.zone.count * 200 + data.partplan.count * 700],
        [
          "Total",
          data.payment.online.count + data.payment.cash.count,
          data.payment.online.amount + data.zone.count * 200 + data.partplan.count * 700,
,
        ],
      ],
      theme: "grid",
      headStyles: { fillColor: [243, 156, 18] },
      margin: { left: 15, right: 15 },
    });

    // Remarks
    const remarksY = doc.lastAutoTable.finalY + 15;
    doc.setFontSize(11);
    doc.text("Remarks:", 15, remarksY);
    doc.text(data.remarks || "No remarks", 15, remarksY + 8);

    // Footer
    doc.setFontSize(9);
    doc.text("© 2025 Sangli Mahanagarpalika - Daily Cash Report", 105, 285, {
      align: "center",
    });

    // File name
    const fileName = `Daily_Cash_Report_${data.date ? data.date.replace(/\//g, '-') : new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(fileName);
  };

  return null;
});

export default DailyCashReportPDF;